/* טקסט: נרמול שמות בתי עסק, ניקוי, ותיקון עברית שנשמרה הפוכה בקבצי בנק */

/** שם בית עסק מנורמל להשוואה: בלי ספרות, סימנים ותווי כיוון */
export function mNorm(s) {
  return String(s || '')
    .replace(/[\u202a-\u202e\u200b-\u200f\u2066-\u2069]/g, '')
    .toLowerCase()
    .replace(/[0-9]/g, ' ')
    .replace(/[^֐-׿a-z ]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** תיאור מקובץ בנק לא אמור להכיל < או > */
export function noTags(s) {
  return s == null ? s : String(s).replace(/[<>]/g, '');
}

export function stripDirMarks(s) {
  return String(s || '').replace(/[\u202a-\u202e\u200b-\u200f\u2066-\u2069]/g, '').trim();
}

/** היפוך מלא, תוך שמירה על סדר ספרות ואותיות לטיניות (מספרי אסמכתא ושמות לועזיים) */
export function reverseKeepRuns(s) {
  const rev = s.split('').reverse().join('');
  return rev.replace(/[0-9A-Za-z][0-9A-Za-z.-]*[0-9A-Za-z]|[0-9A-Za-z]/g, (m) => m.split('').reverse().join(''));
}

/** אותיות סופיות מופיעות בסוף מילה בטקסט תקין, ובתחילת מילה בטקסט הפוך */
export function rtlScore(t) {
  const FIN = 'ךםןףץ';
  let score = 0;
  t.split(/[^א-ת]+/).forEach((w) => {
    if (w.length < 2) return;
    if (FIN.indexOf(w.charAt(w.length - 1)) >= 0) score += 1;
    if (FIN.indexOf(w.charAt(0)) >= 0) score -= 2;
  });
  return score;
}

/** תו LRO פירושו שהטקסט נשמר בסדר התצוגה, כלומר הפוך */
export function isVisualOrder(s) {
  s = String(s || '');
  return /\u202d/.test(s) && (stripDirMarks(s).match(/[א-ת]/g) || []).length >= 2;
}

/* מתקן כיוון לקובץ אחד. יש בנקים שכל הייצוא שלהם הפוך: ההחלטה נעשית פעם אחת לכל גיליון,
   כי מילה בודדת בלי אות סופית לא ניתנת לזיהוי, אבל הקובץ כולו כן */
export function createRtlFixer() {
  let force = false;
  return {
    get force() {
      return force;
    },
    reset() {
      force = false;
    },
    detect(samples) {
      let asIs = 0, flip = 0, n = 0, marked = 0, withHeb = 0;
      (samples || []).forEach((s) => {
        const raw = String(s || '');
        const t = stripDirMarks(raw);
        if ((t.match(/[א-ת]/g) || []).length < 2) return;
        withHeb++;
        if (/[\u202a-\u202e\u2066-\u2069]/.test(raw)) marked++;
        if ((t.match(/[א-ת]/g) || []).length < 3) return;
        asIs += rtlScore(t);
        flip += rtlScore(reverseKeepRuns(t));
        n++;
      });
      if (withHeb >= 3 && marked / withHeb >= 0.5) return (force = true);
      const lro = (samples || []).filter(isVisualOrder).length;
      if (lro && lro / Math.max(1, withHeb) >= 0.5) return (force = true);
      force = n >= 3 && flip > asIs;
      return force;
    },
    fix(s) {
      if (!s) return '';
      s = stripDirMarks(s);
      const heb = (s.match(/[א-ת]/g) || []).length;
      if (heb < 2) return s;
      if (force) return reverseKeepRuns(s);
      if (heb < 3) return s;
      const rev = reverseKeepRuns(s);
      return rtlScore(rev) > rtlScore(s) ? rev : s;
    },
  };
}

/** ניקוי שם על ידי המודל לגיטימי רק אם הוא משמיט מילים. מילה עברית חדשה פירושה שהמודל שיבש */
export function cleanNameGuard(original, clean) {
  if (!clean || clean === original) return clean || original;
  const words = (s) => String(s || '').split(/[^א-ת]+/).filter((w) => w.length >= 2);
  const src = {};
  words(original).forEach((w) => (src[w] = 1));
  const out = words(clean);
  if (!out.length) return clean;
  for (const w of out) if (!src[w]) return original;
  return clean;
}

/** JSON מתוך תשובת מודל: מסיר code fences, מתקן מרכאות לא מוברחות (בע"מ) ומערכים קטועים */
export function extractJSON(text) {
  if (!text) return null;
  text = text.replace(/```json/gi, '').replace(/```/g, '').trim();

  function repairQuotes(s) {
    let out = '', inStr = false, esc = false;
    for (let i = 0; i < s.length; i++) {
      const c = s[i];
      if (esc) { out += c; esc = false; continue; }
      if (c === '\\') { out += c; esc = true; continue; }
      if (!inStr) { if (c === '"') inStr = true; out += c; continue; }
      if (c === '\n' || c === '\r') { out += ' '; continue; }
      if (c === '"') {
        let j = i + 1;
        while (j < s.length && /\s/.test(s[j])) j++;
        const nxt = s[j];
        if (nxt === ':' || nxt === ',' || nxt === '}' || nxt === ']' || nxt === undefined) { inStr = false; out += c; }
        else out += '\\"';
        continue;
      }
      out += c;
    }
    return out;
  }
  function tryParse(s) {
    s = s.replace(/,[ \t\r\n]*([}\]])/g, '$1');
    try { return JSON.parse(s); } catch { /* נמשיך לתיקון */ }
    try { return JSON.parse(repairQuotes(s)); } catch { return null; }
  }

  const ai = text.indexOf('['), oi = text.indexOf('{');
  if (ai === -1 && oi === -1) return null;
  const isArr = ai !== -1 && (oi === -1 || ai < oi);
  if (isArr) {
    const lastClose = text.lastIndexOf(']');
    if (lastClose >= 0) {
      const p = tryParse(text.slice(ai, lastClose + 1));
      if (p) return Array.isArray(p) ? p : [p];
    }
    // מערך קטוע: מחלצים אובייקט אחרי אובייקט
    const slice = lastClose >= 0 ? text.slice(ai, lastClose + 1) : text.slice(ai);
    const objects = [];
    (slice.match(/\{[^{}]*\}/g) || []).forEach((om) => {
      const parsed = tryParse(om);
      if (parsed && parsed.amount !== undefined && parsed.amount !== null) objects.push(parsed);
    });
    return objects.length ? objects : null;
  }
  const lastClose2 = text.lastIndexOf('}');
  if (lastClose2 === -1) return null;
  const p2 = tryParse(text.slice(oi, lastClose2 + 1));
  return p2 ? [p2] : null;
}
